import {combineReducers} from 'redux';
import { i18nState } from 'redux-i18n';
import {language} from './language';
import {currency} from './currency';
import {modals} from './modals';
import {user} from './user';
import {sandos4U} from './sandos4UReducer';
import {catalogue} from './catalogue'
import {authentication} from './authentication';
import {global} from './global';
import {social} from "./social";
import {bookings} from './bookings';
import {bookingForm} from './bookingForm';
import {friends} from "./friends";
import {loading} from "./loading";
import {cart} from "./cart";
import {home} from "./home";

export default combineReducers({
  i18nState,
  authentication,
  bookings,
  global,
  language,
  currency,
  modals,
  catalogue,
  user,
  sandos4U,
  social,
  bookingForm,
  friends,
  loading,
  cart,
  home
})

